import { withNewTabLinks } from '@/shared/tools/htmlHelper'
import { Body } from './styled-components'

interface MessageBodyProps {
  content: string
}

// HTML written by Selectra admins in the communication board editor (Dev Tools).
const MessageBody = ({ content }: MessageBodyProps) => (
  <Body dangerouslySetInnerHTML={{ __html: withNewTabLinks(content) }} />
)

export default MessageBody
